const getItemListSchema = (allProperties = [], inventoryName = "", inventoryUrl = "") => {
  const itemList = allProperties.map((item: any, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: `${item?.name}, ${inventoryName}`,
    url: inventoryUrl,
  }));
  const data = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: itemList,
  };
  return data;
};

export const getStartingPricing = (pricingObject: any) => {
  let price = 0;
  if (pricingObject.min_price) {
    price = pricingObject.min_price;
  } else if (pricingObject.price) {
    price = pricingObject.price;
  }
  return price;
};

export const sortedConfigsAccordingToPrice = (data: any) => {
  const dataArr = [...(data || [])];

  const priceSort = dataArr?.sort((item1: any, item2: any) => {
    const price1 = getStartingPricing(item1.pricing);
    const price2 = getStartingPricing(item2.pricing);
    return price1 - price2;
  });

  const availabilitySort = priceSort.sort(
    (item1: any, item2: any) =>
      item1.tags?.indexOf("not_available") - item2.tags?.indexOf("not_available"),
  );

  // get available rooms first on basis of available flag
  const availableRoomsInFront = availabilitySort.sort(
    (item1: any, item2: any) => Number(item2.available || 0) - Number(item1.available || 0),
  );
  return availableRoomsInFront;
};

const generateRoomTypeSchemaData = (inventoryData: any = {}, inventoryUrl = "") => {
  const allProperties: any = sortedConfigsAccordingToPrice(inventoryData?.children_short);
  const roomtypeSchemaData = getItemListSchema(allProperties, inventoryData?.name, inventoryUrl);
  return [roomtypeSchemaData];
};

export default generateRoomTypeSchemaData;
